import { Head, Link } from '@inertiajs/react';

export default function Welcome() {
    return (
        <>
            <Head title="The One Hex">
                <link rel="preconnect" href="https://fonts.bunny.net" />
                <link
                    href="https://fonts.bunny.net/css?family=cinzel:400,500,600,700&family=crimson-pro:400,400i,500,600"
                    rel="stylesheet"
                />
            </Head>

            <div className="welcome-page">
                {/* Decorative corner flourishes */}
                <div className="welcome-flourish welcome-flourish-tl" />
                <div className="welcome-flourish welcome-flourish-tr" />
                <div className="welcome-flourish welcome-flourish-bl" />
                <div className="welcome-flourish welcome-flourish-br" />

                {/* Main content */}
                <main className="welcome-content">
                    {/* Title with hexagon accent */}
                    <div className="welcome-title-section">
                        <svg
                            className="welcome-hex-icon"
                            viewBox="0 0 100 115"
                            fill="none"
                        >
                            <path
                                d="M50 0L93.3 25V75L50 100L6.7 75V25L50 0Z"
                                fill="currentColor"
                                fillOpacity="0.1"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                            <text
                                x="50"
                                y="58"
                                textAnchor="middle"
                                fill="currentColor"
                                fontSize="32"
                                fontFamily="Cinzel, serif"
                                fontWeight="600"
                            >
                                1
                            </text>
                        </svg>
                        <h1 className="welcome-title">
                            <span className="welcome-title-the">The</span>
                            <span className="welcome-title-one">One</span>
                            <span className="welcome-title-hex">Hex</span>
                        </h1>
                    </div>

                    {/* The Ring Poem parody */}
                    <div className="welcome-poem">
                        <p className="welcome-poem-line">
                            One Hex to rule them all,
                        </p>
                        <p className="welcome-poem-line">
                            One Hex to find them,
                        </p>
                        <p className="welcome-poem-line">
                            One Hex to bring them all,
                        </p>
                        <p className="welcome-poem-line welcome-poem-line-last">
                            And on the hexmap bind them.
                        </p>
                    </div>

                    {/* Decorative divider */}
                    <div className="welcome-divider">
                        <svg
                            viewBox="0 0 200 20"
                            className="welcome-divider-svg"
                        >
                            <path
                                d="M0 10 L70 10 M130 10 L200 10"
                                stroke="currentColor"
                                strokeWidth="1"
                                strokeOpacity="0.4"
                            />
                            <polygon
                                points="100,2 108,10 100,18 92,10"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1"
                                strokeOpacity="0.6"
                            />
                        </svg>
                    </div>

                    {/* Journey Tracker Card */}
                    <Link href="/journey" className="welcome-card">
                        <div className="welcome-card-hex">
                            <svg viewBox="0 0 60 69" fill="none">
                                <path
                                    d="M30 0L56 15V45L30 60L4 45V15L30 0Z"
                                    fill="currentColor"
                                    fillOpacity="0.15"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M30 12L44 21V39L30 48L16 39V21L30 12Z"
                                    fill="currentColor"
                                    fillOpacity="0.1"
                                    stroke="currentColor"
                                    strokeWidth="1"
                                    strokeOpacity="0.6"
                                />
                            </svg>
                        </div>
                        <div className="welcome-card-content">
                            <h2 className="welcome-card-title">
                                Journey Tracker
                            </h2>
                            <p className="welcome-card-description">
                                Track your fellowship's journey across
                                Middle-earth. Mark waypoints, record events, and
                                manage travel fatigue as you traverse the wild.
                            </p>
                            <span className="welcome-card-cta">
                                Begin your journey
                                <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    className="welcome-card-arrow"
                                >
                                    <path
                                        d="M4 10H16M16 10L11 5M16 10L11 15"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        </div>
                    </Link>

                    {/* Subtitle */}
                    <p className="welcome-subtitle">
                        A companion tool for <em>The One Ring</em> Roleplaying
                        Game
                    </p>
                </main>

                {/* Footer with elvish-style decoration */}
                <footer className="welcome-footer">
                    <div className="welcome-runes-container">
                        <div className="welcome-footer-runes">ᚠ ᚢ ᚦ ᚨ ᚱ ᚲ</div>
                        <div className="welcome-runes-tooltip">
                            <div className="welcome-runes-tooltip-header">
                                Elder Futhark
                            </div>
                            <p className="welcome-runes-tooltip-text">
                                The first six runes of the oldest runic
                                alphabet, spelling the beginning of its name:
                            </p>
                            <div className="welcome-runes-tooltip-list">
                                <span>
                                    <strong>ᚠ</strong> Fehu — wealth
                                </span>
                                <span>
                                    <strong>ᚢ</strong> Uruz — strength
                                </span>
                                <span>
                                    <strong>ᚦ</strong> Thurisaz — challenges
                                </span>
                                <span>
                                    <strong>ᚨ</strong> Ansuz — the divine
                                </span>
                                <span>
                                    <strong>ᚱ</strong> Raidho — journey
                                </span>
                                <span>
                                    <strong>ᚲ</strong> Kenaz — knowledge
                                </span>
                            </div>
                            <div className="welcome-runes-tooltip-phonetic">
                                F · U · Th · A · R · K
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}
